export default "__VITE_ASSET__BwEQb4SP__"